import {Component, OnInit} from '@angular/core';
import {CustomNotification, CustomNotificationType} from './model/notification.model';
import {NotificationService} from './service/notification.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    animations: [
        trigger('enterLeave', [
            state('flyIn', style({transform: 'translateY(0)'})),
            transition(':enter', [
                style({transform: 'translateX(110%)'}),
                animate('200ms 0ms linear')
            ]),
            transition(':leave', [
                animate('300ms 0ms linear', style({
                    transform: 'translateX(calc(100% - 1rem))'
                }))
            ])
        ])
    ]
})
export class NotificationComponent implements OnInit {

    notifications: CustomNotification[] = [];
    DISPLAY_TIME = 4000;
    showCloseButton = true;

    constructor(public notificationService: NotificationService) {
    }

    ngOnInit(): void {
        this.notificationService.getAlert().pipe(untilDestroyed(this)).subscribe((alert: CustomNotification) => {
            if (!alert) {
                this.notifications = [];
                return;
            }
            this.notifications.push(alert);

            setTimeout(() => {
                this.removeNotification(alert);
            }, this.DISPLAY_TIME);
        });
    }

    removeNotification(notification: CustomNotification): void {
        this.notifications = this.notifications.filter(x => x !== notification);
    }

    // Set css class for Alert -- Called from alert component
    cssClass(notification: CustomNotification): string {
        if (!notification) {
            return '';
        }
        switch (notification.type) {
            case CustomNotificationType.Success:
                return 'success';
            case CustomNotificationType.Error:
                return 'error';
            case CustomNotificationType.Info:
                return 'info';
            case CustomNotificationType.Warning:
                return 'warning';
        }
    }
}
